import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserStoreService } from './user-store.service';

export interface ApiSurveyCloneResponse {
  newSurveyId: string;
  sourceSurveyId: string;
}

export interface ApiSurveyCreateResponse {
  id: string;
  organizationId: string;
  name: string;
  surveyType: string;
}

export type ApiSurveyCreateErrorCode = "CME400" | "CME403" | "CME404" | "CME409" | "CME500";

@Injectable({ providedIn: 'root' })
export class ApiSurveyCreateService {
  private readonly apiBaseUrl = environment.apiBaseUrl;
  private readonly apiClonePath = '/survey/clone';
  private readonly apiCreatePath = '/survey/create';

  constructor(
    private http: HttpClient,
    private userStore: UserStoreService) {}

  cloneSurvey(organizationId: string, surveyId: string, cloneId: string, name: string, type: string): Observable<ApiSurveyCloneResponse> {
    //Prevent update of other surveys during development, unless the user is a SuperAdmin
    if(organizationId != 'a535f93d-f8c7-421d-a9c9-74f7a17e3761' && !this.userStore.isSuperAdmin()){
      return throwError(() => new Error('This organization/survey is not editable.'));
    }

    const request = {
      id: cloneId,
      name: name,
      type: type,
      organizationId: organizationId,
      clonedId: surveyId,
    };

    return this.http.post<ApiSurveyCloneResponse>(`${this.apiBaseUrl}${this.apiClonePath}`, request);
  }

  createSurvey(organizationId: string, surveyId: string, name: string, surveyType: string): Observable<ApiSurveyCreateResponse> {
    //Prevent update of other surveys during development, unless the user is a SuperAdmin
    if(organizationId != 'a535f93d-f8c7-421d-a9c9-74f7a17e3761' && !this.userStore.isSuperAdmin()){
      return throwError(() => new Error('This organization/survey is not editable.'));
    }

    const request = {
      id: surveyId,
      name: name,
      surveyType: surveyType,
      organizationId: organizationId
    };

    return this.http.post<ApiSurveyCreateResponse>(`${this.apiBaseUrl}${this.apiCreatePath}`, request);
  }
}